export default "__VITE_ASSET__Ckpdh8Dh__"